import React, { cloneElement, Component } from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
// import ArrowUp from 'material-ui/svg-icons/hardware/keyboard-arrow-up';

import store from '../../../redux/store/configureStore';
// import ScrollToTop from '../ScrollToTop';
import ScrollTopArrow from '../ScrollToTopFabButton';
import classBuilder from './classBuilder';
import './Main.scss';

// const scrollToTopStyle = {
//   width: 56,
//   height: 56,
//   bottom: 0,
//   right: 16,
//   zIndex: 900,
//   color: 'white',
//   position: 'fixed',
//   cursor: 'pointer',
//   textAlign: 'center',
//   background: '#1890ff',
//   transitionDelay: '0s',
//   transitionDuration: '0.2s',
//   transitionTimingFunction: 'linear',
// };

const propTypes = {
  page: PropTypes.node.isRequired,
  showFooter: PropTypes.bool.isRequired,
  shopNavOpen: PropTypes.bool.isRequired,
  cartNavOpen: PropTypes.bool.isRequired,
  filterState: PropTypes.object.isRequired,
  handleCartOpen: PropTypes.func.isRequired,
  handleCartClose: PropTypes.func.isRequired,
  handleShopClose: PropTypes.func.isRequired,
  handleCartToggle: PropTypes.func.isRequired,
  containerWidth: PropTypes.number.isRequired,
  handleRouteChange: PropTypes.func.isRequired,
  handleFilterState: PropTypes.func.isRequired,
  globalScrollState: PropTypes.number.isRequired,
  handleRouteStaticRoute: PropTypes.func.isRequired,
  handleGlobalScrollState: PropTypes.func.isRequired,
  handleLogout: PropTypes.func.isRequired,
};

const contextTypes = {
  router: PropTypes.object.isRequired,
};

const shouldShowScrollToTop = location => {
  const locationsToIgnore = [
    '/checkout',
    '/join',
    '/host',
    '/grapeful-club-signup',
  ];
  return !locationsToIgnore.includes(location) && !location.includes('/event/');
};

const isAuthPage = location => {
  return (
    Array.isArray(location.match('/sso')) ||
    Array.isArray(location.match('/login')) ||
    Array.isArray(location.match('/recovery'))
  );
};

class Main extends Component {
  handleMobileScrollToTop = location => {
    switch (location) {
      case '/checkout':
      case '/join':
      case '/host':
      case '/grapeful-club-signup':
        return false;
      default:
        return true;
    }
  };

  render() {
    const { page, shopNavOpen, containerWidth, location, flags } = this.props;
    const isShop = Array.isArray(location.match('shop'));
    const isPDP = Array.isArray(location.match('shop/product'));
    const productCatalogPageV2 = flags && flags.productCatalogPageV2;
    const isAuth = isAuthPage(location);
    const mainClass = isAuth
      ? 'Main plain'
      : location === '/checkout'
      ? 'Main Main-checkout'
      : 'Main';
    const elementToAnimate = cloneElement(page, {
      key: location.pathname,
      ...this.props,
    });
    /* eslint-disable no-return-assign */
    return (
      <Provider store={store}>
        <main id="main" className={mainClass} ref={ref => (this.main = ref)}>
          <div
            id="Main"
            className={classBuilder({
              containerWidth,
              shopNavOpen,
              isShop,
              isAuth,
              isPDP,
              productCatalogPageV2,
            })}
          >
            {elementToAnimate}
          </div>

          {shouldShowScrollToTop(location) && (
            <ScrollTopArrow />
          )}
        </main>
      </Provider>
    );
  }
}

Main.propTypes = propTypes;
Main.contextTypes = contextTypes;

export default Main;
